import { Button } from 'antd';
import React, { useEffect, useState } from 'react';
import { RightOutlined } from '@ant-design/icons';
import { useGlobalState } from './GlobalState';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';

import '../assets/css/dashboard-metrics.css';
import SvgTrendDownArrow from '../../../../../admin/assets/images/Dashboard/TrendDownArrow';
import SvgTrendUpArrow from '../../../../../admin/assets/images/Dashboard/TrendUpArrow';
import SvgOnlineBookings from '../../../../../admin/assets/images/Dashboard/OnlineBookings';
import SvgAdminBookings from '../../../../../admin/assets/images/Dashboard/AdminBookings';
import SvgCancellations from '../../../../../admin/assets/images/Dashboard/Cancellations';
import { useGetDashboardDataQuery } from '../../calendar/eventAdminCalendarSlice';
import StatsCard from '../../stats/components/StatsCard';
import StatsDateRangeSelect from './StatsDateRangeSelect';

export const getTrendIcon = (trend, invertColours = false) => {
  let colours = ['#60BF97', '#CC3D3D'];
  if (invertColours) {
    colours = colours.reverse();
  }
  if (trend === 'incr') {
    return <SvgTrendUpArrow style={{ color: colours[0] }} />;
  }
  if (trend === 'decr') {
    return <SvgTrendDownArrow style={{ color: colours[1] }} />;
  }
  return null;
};

const DEFAULT_START = dayjs();
const DEFAULT_END = dayjs();

function AdminDashboardMetrics() {
  const [kpis, setKpis] = useGlobalState('kpis');
  const [start, setStart] = useState(DEFAULT_START);
  const [end, setEnd] = useState(DEFAULT_END);

  const { data: dashboardData, isFetching: loading } = useGetDashboardDataQuery(
    {
      start: start.format('YYYY-MM-DD'),
      end: end.format('YYYY-MM-DD'),
    }
  );

  useEffect(() => {
    setKpis(dashboardData);
  }, [dashboardData, setKpis]);

  const handleDatesChange = ({ start = dayjs(), end = dayjs() }) => {
    setStart(start);
    setEnd(end);
  };

  const bookingsStats = [
    {
      title: 'Online Bookings',
      icon: <SvgOnlineBookings />,
      value: kpis?.online_bookings?.value || 0,
      trend: kpis?.online_bookings?.trend,
    },
    {
      title: 'Admin Bookings',
      icon: <SvgAdminBookings />,
      value: kpis?.admin_bookings?.value || 0,
      trend: kpis?.admin_bookings?.trend,
    },
    {
      title: 'Cancellations',
      icon: <SvgCancellations />,
      value: kpis?.cancellations?.value || 0,
      trend: kpis?.cancellations?.trend,
      invertColours: true,
    },
  ];

  return (
    <div className='admin-dashboard-metrics'>
      <div className='admin-dashboard-metrics__header mg-bottom-5'>
        <h1 className='gSemiBold mg-bottom-0'>Statistics</h1>
        <div className='admin-dashboard-metrics__date-filter'>
          <StatsDateRangeSelect
            onDatesChange={(selectedRange) => handleDatesChange(selectedRange)}
          />
        </div>
      </div>
      <div className='event_admin-dashboard-metrics__cards'>
        {bookingsStats.map((stat) => (
          <StatsCard
            key={stat.title}
            title={stat.title}
            value={stat.value}
            trend={stat.trend}
            icon={stat?.icon}
            invertColours={stat?.invertColours}
            loading={loading}
          />
        ))}
      </div>
      <Link to={`/event_admin/stats`}>
        <Button className='gSemiBold sb-blue-bg-600 white br10 mg-top-20 mg-bottom-20 pd-20 pd-top-10 pd-bottom-10 antd-link-button-override h-fit fs-16 w-fit row-center justify-center'>
          View More <RightOutlined />
        </Button>
      </Link>
    </div>
  );
}

export default AdminDashboardMetrics;
